import {FormVersionType} from "@Form/types/FormVersion.type";

export default function getFormVersionClassNameAggregator(formVersion: FormVersionType) {
    const v = () => (formVersion === "1" ? "" : "-2")

    return {
        v,
    }
}